export default {
  "Footer.PersonalDataCharter": "パーソナルデータについて",
  "Footer.PrivacyPolicy": "プライバシーポリシー",
  "Footer.ProvisionToThirdParty": "第三者提供先",
  "Footer.FAQ": "よくあるご質問（FAQ）",
  "Footer.CopyRight": "© NTT DOCOMO, INC. All Rights Reserved.",
  "Footer.PrivacyPolicyLink":
    "https://www.docomo.ne.jp/utility/privacy/index.html?utm_source=corp_other&utm_medium=other&utm_campaign=corp_201912_from-pdd01",
}
